import { createFileRoute } from "@tanstack/react-router";

/** @public */
export const Route = createFileRoute("/_auth/messages/drafts")({});
